import React from "react";
import { HashLink } from "react-router-hash-link";

interface IHomeSolutionProps {
  solution: string;
  icon: string;
}

export const HomeSolution: React.FC<IHomeSolutionProps> = ({
  solution,
  icon,
}) => {
  const link = solution.replace(/\s/g, "-");
  return (
    <HashLink smooth to={`/solutions#Solution-${link}`}>
      <div className="Home_Solutions-solution">
        <div className="Home_Solutions-icon">
          <i className={`fas ${icon}`}></i>
        </div>
        <h3>{solution}</h3>
      </div>
    </HashLink>
  );
};
